import React, { lazy, Suspense } from "react";
import { createRoot } from 'react-dom/client';
import Loading from './Components/Loading'

const chunkFailFlag = 'elicence-chunk-reload';

const shouldReloadOnChunkError = () => {
  if (sessionStorage.getItem(chunkFailFlag)) {
    sessionStorage.removeItem(chunkFailFlag);
    return false;
  }
  sessionStorage.setItem(chunkFailFlag, '1');
  return true;
};

// Automatically refresh if a split chunk fails to load (stale HTML or cache)
const handleChunkError = (error) => {
  const message =
    (error && error.message) ||
    (error && error.reason && error.reason.message) ||
    '';
  const isChunkFailure = /Loading chunk [\d]+ failed/i.test(message);
  if (isChunkFailure && shouldReloadOnChunkError()) {
    window.location.reload(true);
  }
};

window.addEventListener('error', (event) => {
  const target = event && event.target;
  const isScript = target && target.tagName === 'SCRIPT';
  const isStaticJs = target && target.src && target.src.indexOf('/static/js/') !== -1;
  if (isScript && isStaticJs) {
    handleChunkError({ message: 'Loading chunk failed' });
  }
});

window.addEventListener('unhandledrejection', handleChunkError);

const UserLandingPage = lazy(() => import("./portal/landingPages/UserLandingPage"));
const AdminLandingPage = lazy(() => import("./portal/landingPages/AdminLandingPage"));

const search = window.location.search;
const params = new URLSearchParams(search);
const mode = params.get('Mode');

const container = document.querySelector("#root");
const root = createRoot(container);

if(mode === 'Admin'){

  root.render(<Suspense fallback={<Loading show={true} /> }>
                  <AdminLandingPage />
              </Suspense>);

} else {

  root.render(<Suspense fallback={<Loading show={true} /> }>
                  <UserLandingPage />
              </Suspense>);

}
